export function createTour({ id, steps, options, shouldStart, onComplete }) {
  return {
    id,
    steps,
    options,
    shouldStart,
    onComplete
  }
}
